import { UsersService } from '@/api/services/users-service'
import { queryCacheConfig } from '@/services/tanstack-query/config'
import { useQuery } from '@tanstack/react-query'

export const GET_ME_SERVICE = 'get-me-service'

export function useGetMeService() {
  return useQuery({
    queryKey: [GET_ME_SERVICE],
    queryFn: () => UsersService.getMe(),
    ...queryCacheConfig,
  })
}
